import React, { Component, PropsWithChildren, useContext } from 'react'
import locales from './locales.json'

type LocalizationContextType = {
  getLocalizedString: (key: keyof Localization, fallback: string) => string
  setLocale: (
    locale: string,
    callBackFunction?: (() => void) | undefined
  ) => void
  locale: string
}
const LocalizationContext = React.createContext({} as LocalizationContextType)

export type Localization = {
  about:string
  close:string
  sendError: string
  connectionError: string
  sendingAudioMessageError: string
  sessionRenewed: string
  yes: string
  no: string
  typeHere: string
  sending: string
  you: string
  getUserMediaError: string
  submitButton: string
  newSession: string
  newSessionIcon: string
  sendIcon: string
  sendMessage:string
  aivaIsTyping: string
  stopChat: string
  stopChatPrompt: string
  languageSwitchPrompt: string
  languageSwitchPromptButton: string
  welcome: string
  startConversation: string
  talkToHuman: string
}

export type LocalizationProps = {
  localization?: Record<string, Localization>
}
class LocalizationProvider extends Component<
  LocalizationProps & PropsWithChildren<{ shouldWrap?: boolean }>,
  {
    locale: string
    sentences: Record<string, Localization>
  }
> {
  state = {
    locale: '',
    sentences: {
      ...locales,
      ...this.props.localization
    }
  }

  getLocalizedString = (key: keyof Localization, fallback: string): string => {
    const { sentences } = this.state
    const locale = this.state.locale as keyof typeof sentences
    if (sentences) {
      const text = sentences[locale] && sentences[locale][key]

      return text || fallback
    }
    return fallback
  }

  setLocale = (locale: string, callBackFunction?: () => void) => {
    this.setState({ locale }, callBackFunction)
  }

  render() {
    const { shouldWrap = true } = this.props

    if (!shouldWrap) return this.props.children

    return (
      <LocalizationContext.Provider
        value={{
          getLocalizedString: this.getLocalizedString,
          setLocale: this.setLocale,
          locale: this.state.locale
        }}
      >
        {this.props.children}
      </LocalizationContext.Provider>
    )
  }
}

export { LocalizationProvider }
export default LocalizationContext

export const useLocalization = () => useContext(LocalizationContext)
